import React from "react";
import { NavLink } from "react-router-dom";
import Auth from "../../utils/auth";

const MenuSlider = (props) => {
  const active = {
    backgroundColor: "#4B8CE5",
    color: "#000",
  };

  let menus = props.accessRights.map((ele, indx) => {
    return ele.functionality;
  });

  let userType = Auth.get("userType");
  let role = Auth.get("role");

  let sideBarMinimizer = (e) => {
    e.preventDefault();
    let bodyElements = document.getElementsByTagName("body");
    if (bodyElements && bodyElements[0]) {
      let body = bodyElements[0];
      if (body.classList.contains("sidebar-minimized")) {
        body.classList.remove("sidebar-minimized");
      } else {
        body.classList.add("sidebar-minimized");
      }
    }
  };

  return (
    <div>
      <div className="sidebar">
        <nav className="sidebar-nav">
          <ul className="nav">
            {userType === "Supplier" ||
            userType === "Customer" ||
            userType === "CustomerSupplier" ? (
              <React.Fragment>
                {menus.indexOf("KYC") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/kyc"
                    >
                      <i className="nav-icon fa fa-info"></i>My KYC
                    </NavLink>
                  </li>
                ) : null}

                {menus.indexOf("KYC Status") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/KycStatus"
                    >
                      <i className="nav-icon fa fa-battery-quarter"></i>
                      KYC Status
                    </NavLink>
                  </li>
                ) : null}

                {menus.indexOf("New Query") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/Query"
                    >
                      <i className="nav-icon fa fa-question"></i>
                      New Query
                    </NavLink>
                  </li>
                ) : null}

                {menus.indexOf("Queries") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/Queries"
                    >
                      <i className="nav-icon fa fa-question"></i>
                      Queries
                    </NavLink>
                  </li>
                ) : null}
              </React.Fragment>
            ) : null}
            {userType === "InternalUser" ? (
              <React.Fragment>
                {menus.indexOf("All Queries") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/Queries"
                    >
                      <i className="nav-icon fa fa-question"></i>
                      Queries
                    </NavLink>
                  </li>
                ) : null}

                {menus.indexOf("KYCS") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/kycs"
                    >
                      <i className="nav-icon fa fa-exclamation  "></i>
                      KYCS
                    </NavLink>
                  </li>
                ) : null}
              </React.Fragment>
            ) : null}
            {userType === "InternalUser" ? (
              <React.Fragment>
                {menus.indexOf("User") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/AdminCreateUser"
                    >
                      <i className="nav-icon fa fa-user"></i>
                      Manage User(s)
                    </NavLink>
                  </li>
                ) : null}

                {menus.indexOf("Registration Correction") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/RegisterCorrection"
                    >
                      <i className="nav-icon  fa fa-check"></i>
                      Registration Correction
                    </NavLink>
                  </li>
                ) : null}

                {menus.indexOf("Location-wise Registration") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/LocationWise"
                    >
                      <i className="nav-icon  fa fa-globe"></i>
                      Location-wise Registration
                    </NavLink>
                  </li>
                ) : null}

                {menus.indexOf("Search Client") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/SearchClient"
                    >
                      <i className="nav-icon  fa fa-search"></i>
                      Search Client
                    </NavLink>
                  </li>
                ) : null}

                {menus.indexOf("Change Client Type") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/ChangeCustomerSupplier"
                    >
                      <i className="nav-icon fa fa-user"></i>
                      Change Client Type
                    </NavLink>
                  </li>
                ) : null}

                {menus.indexOf("Access Rights") > -1 ? (
                  <li className="nav-item">
                    <NavLink
                      style={active}
                      className="nav-link"
                      to="/accessrights"
                    >
                      <i className="nav-icon fa fa-key"></i>
                      Access Rights
                    </NavLink>
                  </li>
                ) : null}
              </React.Fragment>
            ) : null}

            <li className="nav-item">
              <NavLink
                style={active}
                className="nav-link"
                to="/downloads"
              >
                <i className="nav-icon fa fa-download"></i>
                Downloads
              </NavLink>
            </li>
          </ul>
        </nav>

        <a
          className="sidebar-minimizer brand-minimizer"
          onClick={(e) => sideBarMinimizer(e)}
        ></a>
      </div>
    </div>
  );
};
export default MenuSlider;
